<template>
  <div id="quiz">
    <iframe v-if="iframeUrl" class="typeform-widget" data-hj-allow-iframe=""
            :src="iframeUrl"></iframe>
  </div>
</template>

<script>
import publicIp from "public-ip";
import {mapState} from "vuex";
import localforage from "localforage";

export default {
  name: 'quiz',
  props: ['url', 'industry', 'app_id', 'business_id', 'email', 'firstname'],
  data() {
    return {
      uaParam: '',
      ipParam: '',
      fbpParam: '',
      fbcParam: '',
      iframeUrl: null,
      utm: {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        fbclid: null,
      }
    }
  },
  computed: {
    ...mapState('layout', {
      urlParams: state => state.urlParams,
    }),
  },

  mounted() {
    const getInitial = async () => {
      this.uaParam = navigator.userAgent;

      const fbp = document.cookie.split(';').filter(c => c.includes('_fbp=')).map(c => c.split('_fbp=')[1]);
      const fbc = document.cookie.split(';').filter(c => c.includes('_fbc=')).map(c => c.split('_fbc=')[1]);
      this.fbpParam = (fbp.length && fbp[0]) || null;
      this.fbcParam = (fbc.length && fbc[0]) || null;


      this.ipParam = await publicIp.v4();
      await localforage.getItem('utm').then(data => {
        this.utm = {
          utm_source: this.urlParams && this.urlParams.utm_source ? this.urlParams.utm_source : data ? data.utm_source : null,
          utm_medium: this.urlParams && this.urlParams.utm_medium ? this.urlParams.utm_medium : data ? data.utm_medium : null,
          utm_campaign: this.urlParams && this.urlParams.utm_campaign ? this.urlParams.utm_campaign : data ? data.utm_campaign : null,
          utm_term: this.urlParams && this.urlParams.utm_term ? this.urlParams.utm_term : data ? data.utm_term : null,
          utm_content: this.urlParams && this.urlParams.utm_content ? this.urlParams.utm_content : data ? data.utm_content : null,
          fbclid: this.urlParams && this.urlParams.fbclid ? this.urlParams.fbclid : data ? data.fbclid : null,
        }
      });

    };

    const getIframeUrl = () => {

      const url_industry = this.industry ? `industry=${this.industry}` : null;
      const url_app_id = this.app_id ? `app_id=${this.app_id}` : null;
      const url_business_id = this.business_id ? `business_id=${this.business_id}` : null;
      const url_email = this.email ? `email=${this.email}` : null;
      const url_firstname = this.firstname ? `firstname=${this.firstname}` : null;

      const utm_source = this.utm && this.utm.utm_source ? `utm_source=${this.utm.utm_source}` : null;
      const utm_medium = this.utm && this.utm.utm_medium ? `utm_medium=${this.utm.utm_medium}` : null;
      const utm_campaign = this.utm && this.utm.utm_campaign ? `utm_campaign=${this.utm.utm_campaign}` : null;
      const utm_term = this.utm && this.utm.utm_term ? `utm_term=${this.utm.utm_term}` : null;
      const utm_content = this.utm && this.utm.utm_content ? `utm_content=${this.utm.utm_content}` : null;
      const fbclid = (this.utm && this.utm.fbclid) || this.fbcParam ? `fbc=${this.utm.fbclid ? ('fb.1.' + (+new Date()) + '.' + this.utm.fbclid) : this.fbcParam}` : null;
      const fbp = this.fbpParam ? `fbp=${this.fbpParam}` : null;

      const ua = this.uaParam ? `ua=${this.uaParam}` : null;
      const ip = this.ipParam ? `ip=${this.ipParam}` : null;


      const queryArray = [url_industry, url_app_id, url_business_id, url_email, url_firstname, utm_source, utm_medium, utm_campaign, utm_term, utm_content, fbclid, fbp, ua, ip].filter(n => n);
      const query = queryArray.join('&');

      return `https://info536149.typeform.com/to/${this.url}${query ? `${this.url.includes("?") ? '&' : '?'}${query}` : ``}`;
    };

    (async () => {
      await getInitial()
    })().then(() => {
      this.iframeUrl = getIframeUrl();
    });

  },
}
</script>
<style lang="css" scoped>
#quiz {
  background: linear-gradient(to right top, rgb(80, 116, 169), rgb(112, 91, 177), rgb(129, 90, 179), rgb(109, 63, 161), rgb(129, 90, 179), rgb(146, 61, 169), rgb(119, 43, 167), rgb(119, 43, 167), rgb(121, 42, 163), rgb(119, 41, 165), rgb(118, 41, 163), rgb(120, 41, 166));
}

.typeform-widget {
  position: fixed;
  border: none;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.for-tests {
  position: absolute;
  top: 40px;
  left: 40px;
  background-color: #fff;
  border-radius: 20px;
  z-index: 20000000;
  padding: 20px;
  box-shadow: 0 0 30px #00c092;
}
</style>
